import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { AuthResponse } from '../services/api';

interface AuthCtx {
  user: AuthResponse | null;
  login: (resp: AuthResponse) => void;
  logout: () => void;
}

const Ctx = createContext<AuthCtx>({ user: null, login: () => {}, logout: () => {} });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthResponse | null>(() => {
    try {
      const stored = localStorage.getItem('br_user');
      if (!stored) return null;
      const parsed = JSON.parse(stored) as AuthResponse;
      if (!parsed?.token || !parsed?.userId) {
        localStorage.removeItem('br_user');
        localStorage.removeItem('br_token');
        return null;
      }
      return parsed;
    } catch {
      localStorage.removeItem('br_user');
      localStorage.removeItem('br_token');
      return null;
    }
  });

  const login = (resp: AuthResponse) => {
    localStorage.setItem('br_token', resp.token);
    localStorage.setItem('br_user', JSON.stringify(resp));
    setUser(resp);
  };

  const logout = () => {
    localStorage.removeItem('br_token');
    localStorage.removeItem('br_user');
    setUser(null);
  };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);

// Shared by LoginPage (post-login redirect) and App.tsx's root route (already-authenticated
// visitors skip the guest Services page and land straight on their own portal).
export function roleHomePath(role: string): string {
  return role === 'Admin' ? '/admin'
    : role === 'Contractor' ? '/contractor'
    : role === 'Vendor' ? '/vendor'
    : role === 'Client' ? '/client'
    : '/customer';
}
